module.exports = __webpack_public_path__ + "static/media/carCorrect.a5b3722f.png";